import React from 'react'
import { cn, inputVariants } from './utils'

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  variant?: 'default' | 'error'
  inputSize?: 'default' | 'sm' | 'lg'
  error?: boolean
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, variant = 'default', inputSize = 'default', error = false, type, ...props }, ref) => {
    const variantToUse = error ? 'error' : variant
    
    return (
      <input
        type={type}
        className={cn(
          inputVariants.variant[variantToUse],
          inputVariants.size[inputSize],
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)

Input.displayName = 'Input'

export { Input }
